import { CardItem } from '@/components/Card/Card';
import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconBandage from '@/icons/Bandage.svg';
import { getGroupedDefects, useGetDefectName } from '@/models/defectType';
import { ArticleWithRelations } from '@/models/request';

export const ArticleDefectsCell = ({ article }: { article: ArticleWithRelations }) => {
  const getDefectName = useGetDefectName();
  const defects = getGroupedDefects(article.snapshot.articleDefects);

  if (!defects.length) {
    return <InlineText color="secondary">-</InlineText>;
  }

  return (
    <ul>
      {defects.map((defect) => (
        <li key={defect.id}>
          <Paragraph>
            {getDefectName(defect)}
            {defect.quantity > 1 && <> (x{defect.quantity})</>}
          </Paragraph>
        </li>
      ))}
    </ul>
  );
};

export const ArticleDefectsCardItems = ({ article }: { article: ArticleWithRelations }) => {
  const getDefectName = useGetDefectName();
  const defects = getGroupedDefects(article.snapshot.articleDefects);

  return (
    <>
      {defects.map((defect) => (
        <CardItem key={defect.id}>
          <IconBandage style={{ fontSize: '1rem' }} />
          {getDefectName(defect)}
          {defect.quantity > 1 && <> (x{defect.quantity})</>}
        </CardItem>
      ))}
    </>
  );
};
